import React from 'react'

const useGetFeedback = () => {
  
  const triggerFeedbackCampaign = (triggerName: string,availableLanguages?: string[], restaurantLanguage?:string) => {
    const splitRestaurantLanguage = restaurantLanguage?.split('-')[0];
    if(availableLanguages?.includes(splitRestaurantLanguage as any)) {
        return (window as any).usabilla_live('trigger',`${triggerName}_${splitRestaurantLanguage}`)
    } else {
        return (window as any).usabilla_live('trigger',triggerName)
    }
    
  }

  const showFeedback = (visibiltyFlag: boolean) => {
    return visibiltyFlag ? (window as any).usabilla_live('show') : (window as any).usabilla_live('hide')
  }
  return {
    triggerFeedbackCampaign,
    showFeedback
  }
}


export default useGetFeedback;

